import { render, staticRenderFns } from "./ShipmentBatchView.vue?vue&type=template&id=bd0a0c0e&"
import script from "./ShipmentBatchView.vue?vue&type=script&lang=js&"
export * from "./ShipmentBatchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports